import * as React from 'react';
import { Dispatch } from 'redux';
import { UpdateClientViewModel } from 'stageclip-common';

import { BaseApiPatchRequest } from '../generic/baseApiPatchRequest';
import * as ClientNormalizers from '../normalizers/clientNormalizers';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import { toFormData } from '../../helpers/requestHelper';

export class EditClientRequest extends BaseApiPatchRequest<
  UpdateClientViewModel,
  EntityNormalizers.NormalizedSingleEntity<ClientNormalizers.NormalizedClients>
> {
  constructor(clientId: string, formData: UpdateClientViewModel, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/clients/${clientId}`;
    this.normalizeMethod = ClientNormalizers.normalizeClient;
  }

  protected generateRequest() {
    const request = super.generateRequest();
    const { clipConfiguration, ...requestBody } = this.body;

    request.body = toFormData(requestBody);

    if (clipConfiguration) {
      request.body.append(
        'clipConfiguration',
        new Blob([JSON.stringify(clipConfiguration)], {
          type: 'application/json',
        }),
      );
    }

    return request;
  }

  protected generateHeaders() {
    const headers = super.generateHeaders();
    headers.delete('Content-type');

    return headers;
  }
}
